import { convertIUserResponseToUserOverview } from '~/common/converter/user/user';
import type {
  StoryComment,
  StoryCommentsWithTotalCount,
} from '~/common/types/story-comment';
import type {
  CommentCursorResponse,
  CommentResponse,
} from '~/repositories/query-repository';

export const convertICommentResponseToStoryComment = (
  comment: CommentResponse
): StoryComment => {
  const user = convertIUserResponseToUserOverview(comment.user!);
  const stamp = comment.stamp_body
    ? {
        imageUrl: comment.stamp_body.image!.serving_url!,
        alt: comment.stamp_body.alt_text ?? '',
      }
    : null;
  const text = (() => {
    if (comment.deleted_by) {
      if (comment.deleted_by === 'COMMENT_DELETED_BY_COMMENT_OWNER') {
        return {
          body: '投稿者によってコメントが削除されました',
        };
      } else if (comment.deleted_at === 'COMMENT_DELETED_BY_STORY_OWNER') {
        return {
          body: '作者によってコメントが削除されました',
        };
      } else {
        return null;
      }
    } else {
      return comment.text_body
        ? {
            body: comment.text_body ?? '',
          }
        : null;
    }
  })();

  const createdAt = comment.created_at || null;
  const likeCount = comment.like_count || 0;
  const likedByMe = comment.liked_by_me || false;
  const likedByAuthor = comment.liked_by_author || false;
  const replyCount = comment.reply_comment_page?.cursor?.total_count || 0;

  return {
    id: comment.id!,
    user,
    stamp: stamp,
    text: text,
    createdAt,
    likeCount,
    likedByMe,
    likedByAuthor,
    replyCount,
    isDeleted: !!comment.deleted_by,
  };
};

/**
 * QueryServiceから取得したストーリーのリストをStoryの配列に変換するConverter
 * @param response
 * @returns
 */
export const convertICommentSectionResponseToStoryCommentListWithTotalCount = (
  response: CommentCursorResponse
): StoryCommentsWithTotalCount => {
  const totalCount = response.cursor?.total_count || 0;
  const comments =
    response.comment_list?.map(convertICommentResponseToStoryComment) ?? [];

  return {
    totalCount,
    comments,
  };
};
